module.exports = __webpack_public_path__ + "static/media/time-iocn-inactive.56f8438b.svg";